"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createHtmlFromTable = void 0;
var createHtmlFromTable = function (token, options) {
    var classNames = "qwilr-table-scroller project-block__block-element";
    var html = "<div class='".concat(classNames, "'><table class='qwilr-table'>");
    html += "<colgroup>";
    for (var i = 0; i < token.columns; i++) {
        var width = token.columnBorders[i + 1] - token.columnBorders[i];
        html += "<col style=\"width: ".concat(width, "%\" />");
    }
    html += "</colgroup>";
    html += "<tbody>";
    html += renderTableBody(token, options);
    html += "</tbody></table></div>";
    return html;
};
exports.createHtmlFromTable = createHtmlFromTable;
var renderTableBody = function (token, options) {
    var html = "";
    for (var row = 0; row < token.rows; row++) {
        if (row === 0) {
            html += "<tr class='table-header-row'>";
        }
        else {
            html += "<tr>";
        }
        for (var col = 0; col < token.columns; col++) {
            if (token.cells[row] == null || token.cells[row][col] == null) {
                html += "<td><p><br></p></td>";
            }
            else {
                html += "<td>".concat(options.renderTokens(token.cells[row][col]), "</td>");
            }
        }
        html += "</tr>";
    }
    return html;
};
